import { cancelPaymentRequest } from 'entities/payment/api';
import { actionTypes } from 'entities/payment/model/action-types';
import { actions } from 'entities/payment/model/reducer';
import { createAppAsyncThunk, logger } from 'shared';

export const cancelPayment = createAppAsyncThunk<string, number>(
  actionTypes.CANCEL_PAYMENT,
  async (id: number, { dispatch }) => {
    try {
      const { data } = await cancelPaymentRequest({ requestId: id });

      dispatch(actions.setPayment(null));
      dispatch(actions.resetPaymentTokenId());

      return data.message;
    } catch (error) {
      logger(actionTypes.CANCEL_PAYMENT, error);

      throw error;
    }
  },
);
